import React, { useState, useEffect, useContext, useMemo } from 'react';
import { inject, observer } from 'mobx-react';

import RootStore from '../../store/RootStore';
import AllForPersonDetail from '../../components/Followee/AllForPersonDetail';
import AllForJigsaw from '../../components/ComponentNavigator/AllForJigsaw';
import { getFaceUrl } from '../../components/Me/MayBeOneImg';
import { alpha } from '../../utils/color';
import './index.scss';
import wxUtil, { getQueryShareData } from '../../utils/wx';
import URLUtil from '../../utils/url';
import {IPerson} from '../../global.d';

import { ThemeContext } from '../../store/ThemeProvider';
import base64 from 'utils/base64';
import GalleryInstanceStore from '../../components/GalleryList/GalleryInstanceStore';
import { setActiveGalleryInstance, unsetActiveGalleryInstance } from '../../components/GalleryList/ActiveGalleryInstance';
import { setDocumentTitle } from '../../utils/documentTitle';

interface IAllForPagePerson {
  rootStore?: RootStore;
  match: any;
  onBack?: () => void;
}

export const getLocationAvatar = () => {
  const query = new URLSearchParams(window.location.search);
  const encodedAvatar = query.get('avatar') || '';
  if (!encodedAvatar || encodedAvatar === 'null' || encodedAvatar === 'undefined') return '';
  const okRegex = /^(https?:)?\/\//; // Matches http://, https://, or //
  let avatar = encodedAvatar;
  let i = 0;
  const maxAttempts = 10;
  while (i < maxAttempts && !okRegex.test(avatar)) {
    try {
      const decoded = decodeURIComponent(avatar);
      if (decoded === avatar) break;
      avatar = decoded;
    } catch (e) {
      return '';
    }
    i++;
  }
  return avatar;
};

const getGuestName = () => {
  const query = new URLSearchParams(window.location.search);
  return query.get('guest_wall') === '1' ? query.get('guest_name') || '' : '';
};

const AllForPagePerson = (props: IAllForPagePerson) => {
  let { id, personid, openid } = props.match.params!;
  //  avatar是分享页面传递过来的参数, 当然, 为了兼容之前的页面, avatar可以为空, 这样就会使用之前的逻辑
  const avatar = getLocationAvatar();
  const guestName = getGuestName();
  const { mainColor, backgroundColor, componentColor, h1Color } = useContext(
    ThemeContext
  );

  const { relationStore, wxuserStore } = props.rootStore!;
  const [init, setInit] = useState(false);

  // 创建本页独立的 GalleryInstanceStore 并注册为活跃实例，供 AllForJigsaw 读取 jigsaw 状态
  const instanceStore = useMemo(() => new GalleryInstanceStore(props.rootStore!), [props.rootStore]);
  useEffect(() => {
    setActiveGalleryInstance(instanceStore);
    return () => unsetActiveGalleryInstance(instanceStore);
  }, [instanceStore]);

  const setPerson = (person:IPerson)=>{
    relationStore.setPerson(person);
    setInit(true);
  };

  useEffect(() => {
    let galleryid =
      (window.dataDetail ? window.dataDetail!.id : window.gallery.id) + '';

    relationStore.getPersonAlbum(galleryid, personid).then(() => {
      relationStore
        //  覆盖avatar
        .getPerson(galleryid, personid, undefined, openid, avatar)
        .then(() => {
          let target = relationStore.person;
          if (target) {
            if (!target.faceurl) {
              let { data } = relationStore.personAlbum;
              if (data) {
                let targetGallery = data[window.gallery.id] as any;
                if (
                  targetGallery &&
                  targetGallery.images &&
                  targetGallery.images.length > 0
                ) {
                  let image = targetGallery.images[0];
                  // 获取人脸数据
                  wxuserStore.faceMaybe(image.id).then((res: any) => {
                    if (res && res.length) {
                      // let faceurl = getFaceUrl(res[0]);
                      // target.faceurl = faceurl;
                      // setPerson(target);
                      res.forEach((face: any) => {
                        if (face && face.id && face.personid == target.id) {
                          target.faceurl = getFaceUrl(face);
                        }
                      });

                      setPerson(target);
                    }
                  });
                }
              }
            } else {
              setPerson(target);
            }
          }
        });
    });
  }, []);

  useEffect(() => {
    const shareQuery = getQueryShareData();

    setDocumentTitle(guestName || shareQuery.t, guestName ? '嘉宾照片' : '专属相册');

    wxUtil.configShare({
      title: shareQuery.t || undefined,
      image: shareQuery.i || undefined,
      url: window.location.href,
      desc: shareQuery.d || '好友分享给您的照片，请查看'
    });
  }, [guestName]);

  return (
    <div
      className={`all-for-pageperson${guestName ? ' guest-wall-person-page' : ''}`}
      style={{ backgroundColor: alpha(componentColor, 1) }}
    >
      {init ? <>
        <AllForPersonDetail hideBack={!props.onBack} showCurrentGallery={true} onBack={props.onBack} />
        <AllForJigsaw from="src/pages/Person/index.tsx:129" />
      </> : undefined}
    </div>
  );
};

export default inject('rootStore')(observer(AllForPagePerson));
